import React, { useState } from 'react';
import { Card, Upload, Button, Table, Space, message, Modal, Form, Input, Select } from 'antd';
import { UploadOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { fileApi } from '../services/api';

const { Option } = Select;

const DataTemplate = () => {
  const [data, setData] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [form] = Form.useForm();

  const columns = [
    {
      title: '产品链接',
      dataIndex: 'productLink',
      key: 'productLink',
    },
    {
      title: '国家',
      dataIndex: 'country',
      key: 'country',
    },
    {
      title: '模板',
      dataIndex: 'template',
      key: 'template',
    },
    {
      title: '品牌名',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  const templateColumns = [
    {
      title: '模板名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setData(jsonData);
        message.success('数据导入成功');
      } catch (error) {
        message.error('文件解析失败');
      }
    };
    reader.onerror = () => {
      message.error('文件读取失败');
    };
    reader.readAsBinaryString(file);
    return false; // 阻止默认上传行为
  };

  const handleAddTemplate = () => {
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingTemplate(record);
    form.setFieldsValue(record);
    setIsModalVisible(true);
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除这个模板吗？',
      onOk: async () => {
        try {
          await fileApi.deleteFile(id);
          message.success('模板删除成功');
          setTemplates(templates.filter(t => t.id !== id));
        } catch (error) {
          message.error('模板删除失败');
        }
      },
    });
  };

  const handleSave = async (values) => {
    try {
      if (editingTemplate) {
        await fileApi.updateFile(editingTemplate.id, values);
        message.success('模板更新成功');
      } else {
        await fileApi.createFile(values);
        message.success('模板创建成功');
      }
      setIsModalVisible(false);
      form.resetFields();
      setEditingTemplate(null);
    } catch (error) {
      message.error('保存失败');
    }
  };

  return (
    <div>
      <Card title="数据整理" style={{ marginBottom: 16 }}>
        <Space style={{ marginBottom: 16 }}>
          <Upload
                            accept=".xlsx,.xls,.xlsm"
            beforeUpload={handleFileUpload}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>导入Excel</Button>
          </Upload>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAddTemplate}>
            添加模板
          </Button>
        </Space>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Card title="模板管理">
        <Table
          columns={templateColumns}
          dataSource={templates}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Modal
        title={editingTemplate ? '编辑模板' : '添加模板'}
        visible={isModalVisible}
        onOk={form.submit}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
          setEditingTemplate(null);
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
        >
          <Form.Item
            name="name"
            label="模板名称"
            rules={[{ required: true, message: '请输入模板名称' }]}
          >
            <Input placeholder="请输入模板名称" />
          </Form.Item>
          <Form.Item
            name="type"
            label="模板类型"
            rules={[{ required: true, message: '请选择模板类型' }]}
          >
            <Select placeholder="请选择模板类型">
              <Option value="product">产品模板</Option>
              <Option value="category">类目模板</Option>
              <Option value="custom">自定义模板</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DataTemplate; 